import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Users, FileSignature } from 'lucide-react';
export function Procurement() {
  const steps = [{
    icon: <Users className="w-8 h-8 text-au-gold" data-id="element-245" />,
    title: 'Supplier Registration',
    description: 'Register your business in our supplier database to be eligible for future bidding opportunities.',
    to: '/procurement/supplier-registration'
  }, {
    icon: <FileSignature className="w-8 h-8 text-au-gold" data-id="element-246" />,
    title: 'Submission Guidelines',
    description: 'Review our standard bidding documents and learn how to prepare a compliant proposal.',
    to: '/procurement'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-au-gold" data-id="element-247" />,
    title: 'Procurement Manual',
    description: 'Understand the policies, procedures, and ethical standards governing our procurement processes.',
    to: '/procurement'
  }];
  return <section id="procurement" className="py-20 bg-gray-50 border-t border-gray-200" data-id="element-248">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-249">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-12" data-id="element-250">
          <div className="md:w-1/2 mb-6 md:mb-0" data-id="element-251">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-au-navy mb-4" data-id="element-252">
              Doing Business with Us
            </h2>
            <div className="h-1 w-16 bg-au-gold mb-6" data-id="element-253"></div>
            <p className="text-gray-600 text-lg" data-id="element-254">
              The African Union Commission is committed to procuring goods,
              works, and services in a manner that ensures transparency,
              fairness, and value for money.
            </p>
          </div>
          <div className="md:w-1/3" data-id="element-255">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-256">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-257">Need Assistance?</h4>
              <p className="text-sm text-gray-600 mb-4" data-id="element-258">
                Contact our procurement support team for guidance on the bidding
                process.
              </p>
              <a href="mailto:procurement@aucommissions.org" className="text-au-green font-medium hover:underline" data-id="element-259">
                procurement@aucommissions.org
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-260">
          {steps.map((step, index) => <Link key={index} to={step.to} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 hover:border-au-green transition-colors group block focus:outline-none focus:ring-2 focus:ring-au-green focus:ring-offset-2" data-id="element-261">
              <div className="w-16 h-16 bg-au-navy rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-262">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-263">
                {step.title}
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-264">{step.description}</p>
              <span className="text-au-green font-medium text-sm group-hover:underline" data-id="element-265">
                Learn more →
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}